class burgerMenu extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const burgerButton = this.querySelector('.burgerMenu-button')

        burgerButton.addEventListener('click', () => {
            this.toggleAttribute('data-menu-opened')
        })

    }
}

customElements.define("cstm-burger-menu", burgerMenu);